import React from 'react';
import { useRecoilValue } from 'recoil';
import { useBreakpoints } from 'common/hooks/use-breakpoints';
import { formatNumber } from 'utils/format-number.helper';
import { surfacesTypes } from 'pages/surface/const';
import { dimensionsAtom } from 'pages/dimensions/store/dimensions';
import {
  TableContainer,
  SurfaceColumnContainer,
  MaterialColumnContainer,
  AreaColumnContainer,
  VolumeColumnContainer,
} from '../result.styles';
import { Header, SurfaceCell, AreaCell, EmptyCell, Material, Volume, MaterialHeader } from '../Cells';

type TSurfaceName = 'WALL' | 'FLOOR' | 'CEILING';

export const TableComponent = () => {
  const { desktop, largeDesktop } = useBreakpoints() ?? {};
  const isLargeScreen = desktop || largeDesktop;

  const dimensions = useRecoilValue(dimensionsAtom);
  const { items, surface: dimensionsSurface } = dimensions;
  const surfacesData = items[0].surface;
  const surfaces = Object.keys(surfacesData).map(surf => {
    const findedSurface = surfacesTypes.find(s => surf === s.name.toUpperCase());
    return {
      name: findedSurface?.name?.toUpperCase() as TSurfaceName,
      label: findedSurface?.label as string,
    };
  });

  const hasMaterial = surfaces.some(surface => dimensionsSurface[surface.name]?.baseSurface);
  const hasVolume = surfaces.some(surface => surfacesData[surface.name]?.requiredVolume);

  return (
    <TableContainer>
      <SurfaceColumnContainer>
        <Header title="Поверхность" />
        {surfaces.map(surface => (
          <div key={surface.name}>
            <SurfaceCell title={surface.label} />
            {!isLargeScreen && hasMaterial && (
              <Material baseSurface={dimensionsSurface[surface.name]?.baseSurface} />
            )}
          </div>
        ))}
      </SurfaceColumnContainer>
      {isLargeScreen ? (
        <MaterialColumnContainer>
          <MaterialHeader hasMaterial={hasMaterial} />
          {surfaces.map(surface => (
            <Material key={surface.name} baseSurface={dimensionsSurface[surface.name]?.baseSurface} />
          ))}
        </MaterialColumnContainer>
      ) : null}
      <AreaColumnContainer>
        <Header title="Площадь" />
        {surfaces.map(surface => (
          <AreaCell
            key={surface.name}
            isDoubleCell={!isLargeScreen && hasMaterial}
            title={`${formatNumber(surfacesData[surface.name]?.area)} м²`}
          />
        ))}
      </AreaColumnContainer>
      <VolumeColumnContainer>
        {hasVolume ? <Header title="Объём" /> : <EmptyCell />}
        {surfaces.map(surface => (
          <Volume
            key={surface.name}
            isDoubleCell={!isLargeScreen && hasMaterial}
            requiredVolume={formatNumber(surfacesData[surface.name]?.requiredVolume, 1)}
          />
        ))}
      </VolumeColumnContainer>
    </TableContainer>
  );
};
